import DoradoSearchResult from '../store/schema/DoradoSearchResult';

export default function getDordaoSearchResultsFromJson(
    doradoSearchResponseJson: any
): DoradoSearchResult[] {
    const actions = doradoSearchResponseJson.suggestedActions.actions;
    const entities = doradoSearchResponseJson.entities as object[];
    const results: DoradoSearchResult[] = actions.map(action => {
        return {
            title: action.title,
            subTitle: action.value.Payload.ActionDescription,
            imageUrl: action.image,
            doradoAction: action,
            doradoEntities: entities,
        };
    });

    return results;
}
